import React from 'react';
import _ from 'lodash';
import { InputNumber, Icon, message } from 'antd';
import CONST from '../constants';

const ResolutionSelect = React.createClass({
  getInitialState() {
    return {
      width: this.props.defaultWidth,
      height: this.props.defaultHeight,
      debouncedWidthChange: _.debounce(this._onWidthChange, 500),
      debouncedHeightChange: _.debounce(this._onHeightChange, 500),
      debouncedMessage: _.debounce(this._message, 700),
    };
  },

  render() {
    return <div className="ResolutionSelect">
      <InputNumber step={10} className="ResolutionSelect__width" defaultValue={this.state.width} onChange={this.state.debouncedWidthChange} />
      <Icon type="close" />
      <InputNumber step={10} className="ResolutionSelect__height" defaultValue={this.state.height} onChange={this.state.debouncedHeightChange} />
    </div>
  },

  _onWidthChange(width) {
    const didChange = width !== this.state.width;
    this.setState({ width });

    if (!_.isFinite(width)) {
      this.state.debouncedMessage('Incorrect width.', (w, h) => !_.isFinite(w));
      return;
    }

    if (width > 3000 || width < 300) {
      this.state.debouncedMessage('Incorrect width. It must be between 300 and 3000.', (w, h) => w > 3000 || w < 300);
      return;
    }

    const maxPix = 1440 * 3000;
    const maxW = Math.round(maxPix / this.state.height);

    if (width * this.state.height > maxPix) {
      this.state.debouncedMessage(`Too large image. Set width below ${maxW}.`, (w, h) => w * h > maxPix);
      return;
    }

    if (didChange) {
      this._emit();
    }
  },

  _onHeightChange(height) {
    const didChange = height !== this.state.height;
    this.setState({ height });

    if (!_.isFinite(height)) {
      this.state.debouncedMessage('Incorrect height.', (w, h) => !_.isFinite(h));
      return;
    }

    if (height > 3000 || height < 300) {
      this.state.debouncedMessage('Incorrect height. It must be between 300 and 3000.', (w, h) => h > 3000 || h < 300);
      return;
    }

    const maxPix = 1440 * 3000;
    const maxH = Math.round(maxPix / this.state.width);

    if (height * this.state.width > maxPix) {
      this.state.debouncedMessage(`Too large image. Set height below ${maxH}.`, (w, h) => w * h > maxPix);
      return;
    }

    if (didChange) {
      this._emit();
    }
  },

  _emit() {
    this.props.onChange(this.state);
  },

  _message(msg, verify) {
    if (verify(this.state.width, this.state.height)) {
      message.error(msg);
    }
  }
});


export default ResolutionSelect;



// WEBPACK FOOTER //
// ./src/components/ResolutionSelect.jsx